import { useGomakeTheme } from "@/hooks/use-gomake-thme";

export const EcommerceIcon = () => {
  const { primaryColor } = useGomakeTheme();
  const stroke = primaryColor(500);

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.41667 6.25H14.5833L15.4167 16.25H4.58333L5.41667 6.25Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 6.25V5.41667C7.5 4.03596 8.61929 2.91667 10 2.91667C11.3807 2.91667 12.5 4.03596 12.5 5.41667V6.25"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9.16667V10"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 9.16667V10"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
